import React, { useState, useEffect } from 'react';
import { isSoundActive, toggleSound, onSoundToggle } from '../utils/soundEffects';
import './SoundToggle.css';

const SoundToggle = () => {
  const [isEnabled, setIsEnabled] = useState(isSoundActive());

  useEffect(() => {
    const unsubscribe = onSoundToggle((enabled) => {
      setIsEnabled(enabled);
    });
    return unsubscribe;
  }, []);

  const handleToggle = () => {
    const newState = toggleSound();
    setIsEnabled(newState);
  };

  return (
    <button 
      className={`sound-toggle ${isEnabled ? 'enabled' : 'disabled'}`}
      onClick={handleToggle}
      aria-label={isEnabled ? 'Disable Sound' : 'Enable Sound'}
    >
      {isEnabled ? (
        <span className="sound-icon">🔊</span>
      ) : (
        <span className="sound-icon">🔇</span>
      )}
      <span className="sound-text">SOUND</span>
    </button>
  );
};

export default SoundToggle;